interface InvoiceFinancialMasks {
  pricingHidden: boolean;
  paymentInfoHidden: boolean;
  /**
   * Accepted so every caller states all three invoice-relevant masks, but it
   * decides nothing here. The server stopped masking an invoice's own
   * `amountPaid` / `balanceDue` under CUSTOMER_FINANCIALS (#2999), so a sales
   * rep reads the balance on the invoices they chase. What the category still
   * covers (credits, customer A/R, money in flight, payment actions) is gated
   * at each of those sites, not through these flags.
   */
  customerFinancialsHidden: boolean;
}

/** Keep frontend visibility aligned with the backend field-mask catalog. */
export function getInvoiceFinancialVisibility({
  pricingHidden,
  paymentInfoHidden,
}: InvoiceFinancialMasks) {
  const paymentAmountsHidden = pricingHidden || paymentInfoHidden;

  return {
    invoiceTotalsHidden: pricingHidden,
    paymentAmountsHidden,
    // PRICING and PAYMENT_INFO both list the invoice's own paid and balance
    // on the server; CUSTOMER_FINANCIALS does not.
    invoiceBalancesHidden: paymentAmountsHidden,
  };
}
